import { useEffect, useState } from 'react';

/** The time, moving every [every] ms: times and counts refresh as the day goes (`liveClockProvider` on the phone). */
export function useNow(every = 15_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), every);
    return () => clearInterval(t);
  }, [every]);
  return now;
}
